$(document).ready(function() {
  // console.log('template_product-item.js loaded');

  /* 文字列を指定文字数でトリム */
  function textTrim(text, count) {
    if (!text) return '';
    if (text.length > count) {
      return text.substring(0, count) + '…';
    }
    return text;
  }

  // 端末幅はループの外で一回だけ判定
  var isSpWidth = window.matchMedia('(max-width: 600px)').matches;
  var maxTitleLength = isSpWidth ? 22 : 22;

  var $products = $('.js-section-product');
  if (!$products.length) {
    return;
  }

  $products.each(function() {
    var $item = $(this);

    // data-* は jQuery がキャッシュしてくれるので1回だけ取得
    var itemTitleFromData = $item.data('product-item-title') || '';
    var tags = $item.data('product-tags');

    var baseModelTag = null;     // mo_XXX
    var baseH1Tag = null;        // h1_XXX
    var productNameTag = null;   // productname_XXX

    // tags が配列である場合のみ安全に処理
    if (Array.isArray(tags) && tags.length) {
      // ★ ここが一番重くなりがちな部分なので、find() 3連発をやめて
      //    1ループで必要なタグを全部拾うようにしている
      for (var i = 0, len = tags.length; i < len; i++) {
        var code = tags[i];

        if (!baseModelTag && code.indexOf('mo_') === 0) {
          baseModelTag = code;
          continue;
        }
        if (!baseH1Tag && code.indexOf('h1_') === 0) {
          baseH1Tag = code;
          continue;
        }
        if (!productNameTag && code.indexOf('productname_') === 0) {
          productNameTag = code;
          continue;
        }

        // 3つ全部見つかったらループ終了
        if (baseModelTag && baseH1Tag && productNameTag) {
          break;
        }
      }
    }

    /* モデル名表示（例: iPhone 16 / Pixel 10 など） */
    if (baseModelTag && window.fox && window.fox.settings && window.fox.settings.model) {
      // "mo_AP2251" → "AP2251"
      var parts = baseModelTag.split('_');
      var modelCode = parts.length > 1 ? parts[1] : null;

      if (modelCode) {
        var modelName = window.fox.settings.model[modelCode];
        if (modelName) {
          $item.find('.js-model').text(modelName);
        }
      }
    }

    /* ケース種別表示（例: スリムプロテクションケース など） */
    if (baseH1Tag && window.fox && window.fox.settings && window.fox.settings.h1) {
      var caseTypeName = window.fox.settings.h1[baseH1Tag];
      if (caseTypeName) {
        $item.find('.js-casetype').text(caseTypeName);
      }
    }

    var displayTitle = window.caseplayDisplayTitle(itemTitleFromData, productNameTag);

    if (displayTitle) {
      displayTitle = textTrim(displayTitle, maxTitleLength);
      $item.find('.js-item-title').text(displayTitle);
    }
  });

  if ($(document).hasClass('collection-title')) {
    var collection_title = $('.collection-title').html();
    $('.collection-title').html(
      collection_title.replace(/h2_.+?\s/i, '')
    );
  }

  /* パンくずリストのh2タグを消す */
  if ($(document).hasClass('breadcrumbs-inner')) {
    var breadcrumbs_inner = $('.breadcrumbs-inner').html();
    if (breadcrumbs_inner && breadcrumbs_inner.match(/h2_/)) {
      $('.breadcrumbs-inner').html(
        breadcrumbs_inner.replace(/h2_.+?\s/i, '').replace(/\+/, '')
      );
    }
  }
});
